import axios from "@/api/axiosInstance";
import { DeleteProcessWheelResponse } from "./types";

export const deleteProcessWheel = async (
  uuid: string,
): Promise<DeleteProcessWheelResponse> => {
  const response = await axios.delete<DeleteProcessWheelResponse>(
    `/api/private/admin/process-wheels/${uuid}`,
  );
  return response.data;
};
